
// import { useEffect, useRef, useState } from "react";
// import { Close, Pack } from "../../components/icons/Icon";
// import { CloseIcon } from "../../components/icons/Icon2";
// import Button from "../../components/updatedComponents/Dealers/Button";
// import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
// import { handleFileData } from "../../APIsControll/apiControl2";
// import fetchData from "../../APIsControll/apiControll";
// import styles from "./PackProdAndSaleVoucherModal.module.css";

// const IMG_BASE =
//   process.env.REACT_APP_S3URL || process.env.REACT_APP_S3URLA || "";

// let boxCounter = 0;
// const newBox = (file = null) => ({
//   id: ++boxCounter,
//   file,
//   preview: file ? URL.createObjectURL(file) : null,
// });

// const DropIcon = () => (
//   <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
//     <rect
//       x="12"
//       y="14"
//       width="24"
//       height="18"
//       rx="4"
//       stroke="#C0393B"
//       strokeWidth="2"
//     />
//     <rect
//       x="4"
//       y="6"
//       width="24"
//       height="18"
//       rx="4"
//       stroke="#6B7499"
//       strokeWidth="2"
//       fill="#1B1D21"
//     />
//   </svg>
// );

// const PackProdAndSaleVoucherModal = ({
//   mode,
//   closeModal,
//   managerId,
//   orderId, // voucherId
//   getData, // getData(true) must return the latest packingImgs array
//   packingImgs = [],
// }) => {
//   const { show } = useToast();

//   const [uploadedImgs, setUploadedImgs] = useState(packingImgs || []);
//   const [boxes, setBoxes] = useState(() => [newBox()]);
//   const [uploading, setUploading] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [dragId, setDragId] = useState(null);

//   const inputRefs = useRef({});
//   const boxesRef = useRef(boxes);
//   boxesRef.current = boxes;

//   const packCount = uploadedImgs.length;
//   const selectedBoxes = boxes.filter((b) => b.file);

//   useEffect(
//     () => () => {
//       boxesRef.current.forEach(
//         (b) => b.preview && URL.revokeObjectURL(b.preview),
//       );
//     },
//     [],
//   );

//   const addBox = () => setBoxes((prev) => [newBox(), ...prev]);

//   const removeBox = (id) => {
//     const target = boxesRef.current.find((b) => b.id === id);
//     if (target?.preview) URL.revokeObjectURL(target.preview);
//     setBoxes((prev) => {
//       const next = prev.filter((b) => b.id !== id);
//       return next.length ? next : [newBox()];
//     });
//   };

//   // Click-select and drag-drop both use this.
//   // First image fills this box, extra images get their own new boxes.
//   const pickFiles = (id, fileList) => {
//     const files = Array.from(fileList || []).filter((f) =>
//       f.type.startsWith("image/"),
//     );
//     if (files.length === 0) {
//       show("Please select an image file.", "warning");
//       return;
//     }

//     const [first, ...rest] = files;
//     const firstPreview = URL.createObjectURL(first);
//     const extras = rest.map((f) => newBox(f));

//     const old = boxesRef.current.find((b) => b.id === id);
//     if (old?.preview) URL.revokeObjectURL(old.preview);

//     setBoxes((prev) => [
//       ...extras,
//       ...prev.map((b) =>
//         b.id === id ? { ...b, file: first, preview: firstPreview } : b,
//       ),
//     ]);
//   };

//   const openPicker = (id) => {
//     if (uploading) return;
//     inputRefs.current[id]?.click();
//   };

//   const handleDrop = (e, id) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setDragId(null);
//     if (uploading) return;
//     pickFiles(id, e.dataTransfer.files);
//   };

//   // ONE button -> uploads all selected images in a single request
//   const handleUploadAll = async () => {
//     if (selectedBoxes.length === 0) {
//       show("Please select at least one image.", "warning");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("managerId", managerId);
//     formData.append("voucherId", orderId);
//     selectedBoxes.forEach((b) => formData.append("images", b.file));

//     try {
//       setUploading(true);
//       const res = await handleFileData(
//         "packing/uploadMultiPackedImg",
//         formData,
//       );

//       if (res.status === "success") {
//         show(res.msg || "Images uploaded", "success");
//         const latest = await getData(true);
//         if (Array.isArray(latest)) setUploadedImgs(latest);

//         selectedBoxes.forEach(
//           (b) => b.preview && URL.revokeObjectURL(b.preview),
//         );
//         setBoxes((prev) => {
//           const next = prev.filter((b) => !b.file);
//           return next.length ? next : [newBox()];
//         });
//       } else {
//         show(res.msg || "Image upload failed", "error");
//       }
//     } catch (error) {
//       console.error(error);
//       show("Image upload failed", "error");
//     } finally {
//       setUploading(false);
//     }
//   };

//   const PackOrder = async () => {
//     if (selectedBoxes.length > 0) {
//       show("Please upload the selected images first.", "warning");
//       return;
//     }
//     if (packCount === 0) {
//       show("Please upload at least one image.", "warning");
//       return;
//     }
//     try {
//       setLoading(true);
//       const res = await fetchData("packing/prodAndSaleVoucherPacked", {
//         managerId,
//         voucherId: orderId,
//         packingQty: packCount,
//       });
//       if (res.status === "success") {
//         show(res.msg || "Voucher packed", "success");
//         getData();
//         closeModal();
//       } else {
//         show(res.msg || "Unable to pack voucher", "error");
//       }
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className={`${styles.modal} ${mode ? styles.dark : ""}`}>
//       {/* ---------- Header ---------- */}
//       <div className={styles.header}>
//         <div className={styles.headerLeft}>
//           <p className={styles.title}>Pack Voucher</p>
//           <span className={styles.countBadge}>
//             {packCount} pack{packCount === 1 ? "" : "s"} uploaded
//           </span>
//         </div>
//         <div className={styles.closeBtn} onClick={closeModal}>
//           <CloseIcon mode={mode} />
//         </div>
//       </div>

//       <div className={styles.list}>
//         {/* ---------- To upload (top) ---------- */}
//         <div className={styles.section}>
//           <div className={styles.sectionHead}>
//             <p className={styles.sectionTitle}>To upload</p>
//             <span className={styles.sectionCount}>{boxes.length}</span>
//           </div>

//           <div className={styles.grid}>
//             {boxes.map((box, i) => (
//               <div className={styles.tile} key={box.id}>
//                 <p className={styles.tileLabel}>
//                   Pack {packCount + boxes.length - i}
//                 </p>

//                 {box.preview ? (
//                   <div
//                     className={`${styles.frame} ${
//                       uploading ? styles.dropBusy : ""
//                     }`}
//                   >
//                     <img
//                       className={styles.img}
//                       src={box.preview}
//                       alt="Selected"
//                       draggable={false}
//                     />
//                     <span className={`${styles.badge} ${styles.badgeNew}`}>
//                       Ready
//                     </span>
//                     {!uploading && (
//                       <button
//                         type="button"
//                         className={styles.removeBtn}
//                         onClick={() => removeBox(box.id)}
//                         aria-label="Remove image"
//                       >
//                         ×
//                       </button>
//                     )}
//                   </div>
//                 ) : (
//                   <div
//                     role="button"
//                     tabIndex={0}
//                     className={`${styles.frame} ${styles.drop} ${
//                       dragId === box.id ? styles.dropActive : ""
//                     } ${uploading ? styles.dropBusy : ""}`}
//                     onClick={() => openPicker(box.id)}
//                     onKeyDown={(e) => {
//                       if (e.key === "Enter" || e.key === " ") {
//                         e.preventDefault();
//                         openPicker(box.id);
//                       }
//                     }}
//                     onDragEnter={(e) => {
//                       e.preventDefault();
//                       setDragId(box.id);
//                     }}
//                     onDragOver={(e) => {
//                       e.preventDefault();
//                       e.dataTransfer.dropEffect = "copy";
//                       if (dragId !== box.id) setDragId(box.id);
//                     }}
//                     onDragLeave={(e) => {
//                       if (!e.currentTarget.contains(e.relatedTarget))
//                         setDragId(null);
//                     }}
//                     onDrop={(e) => handleDrop(e, box.id)}
//                   >
//                     <div className={styles.dropContent}>
//                       <DropIcon />
//                       <p className={styles.dropTitle}>
//                         Drag &amp; Drop any file
//                       </p>
//                       <p className={styles.dropOr}>
//                         or <span className={styles.browse}>browse files</span>{" "}
//                         on your computer
//                       </p>
//                     </div>

//                     {!uploading && boxes.length > 1 && (
//                       <button
//                         type="button"
//                         className={styles.removeBtn}
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           removeBox(box.id);
//                         }}
//                         aria-label="Remove box"
//                       >
//                         ×
//                       </button>
//                     )}

//                     <input
//                       ref={(el) => (inputRefs.current[box.id] = el)}
//                       className={styles.hiddenInput}
//                       type="file"
//                       accept="image/*"
//                       multiple
//                       onClick={(e) => e.stopPropagation()}
//                       onChange={(e) => {
//                         pickFiles(box.id, e.target.files);
//                         e.target.value = "";
//                       }}
//                     />
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* ---------- Uploaded (below) ---------- */}
//         <div className={styles.section}>
//           <div className={styles.sectionHead}>
//             <p className={styles.sectionTitle}>Uploaded</p>
//             <span className={styles.sectionCount}>{uploadedImgs.length}</span>
//           </div>

//           {uploadedImgs.length === 0 ? (
//             <p className={styles.emptyNote}>No packs uploaded yet.</p>
//           ) : (
//             <div className={styles.grid}>
//               {uploadedImgs.map((path, i) => (
//                 <div className={styles.tile} key={path + i}>
//                   <p className={styles.tileLabel}>Pack {i + 1}</p>
//                   <div className={styles.frame}>
//                     <a
//                       className={styles.imgLink}
//                       href={`${IMG_BASE}${path}`}
//                       target="_blank"
//                       rel="noreferrer"
//                     >
//                       <img
//                         className={styles.img}
//                         src={`${IMG_BASE}${path}`}
//                         alt={`Pack ${i + 1}`}
//                       />
//                     </a>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* ---------- Footer ---------- */}
//       <div className={styles.footer}>
//         <div className={styles.footerLeft}>
//           <Button
//             buttonBgColor={"#000000"}
//             buttonTextColor={"#FFFFFF"}
//             buttonText={"+ Add Pack"}
//             buttonClick={addBox}
//             disabled={uploading}
//           />
//           <Button
//             buttonBgColor={"#4164E3"}
//             buttonTextColor={"#FFFFFF"}
//             buttonText={`Upload${selectedBoxes.length ? ` (${selectedBoxes.length})` : ""}`}
//             buttonClick={handleUploadAll}
//             loading={uploading}
//             disabled={uploading || selectedBoxes.length === 0}
//           />
//         </div>
//         <div className={styles.footerRight}>
//           <Button
//             buttonBgColor={"#000000"}
//             buttonTextColor={"#FFFFFF"}
//             buttonText={"Close"}
//             buttonIcon={<Close />}
//             buttonClick={closeModal}
//           />
//           <Button
//             buttonBgColor={"#4164E3"}
//             buttonTextColor={"#FFFFFF"}
//             buttonText={"Pack"}
//             buttonIcon={<Pack />}
//             buttonClick={PackOrder}
//             loading={loading}
//             disabled={loading || uploading || packCount === 0}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PackProdAndSaleVoucherModal;


import { useEffect, useRef, useState } from "react";
import { Close, Pack } from "../../components/icons/Icon";
import { CloseIcon } from "../../components/icons/Icon2";
import Button from "../../components/updatedComponents/Dealers/Button";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import { handleFileData } from "../../APIsControll/apiControl2";
import fetchData from "../../APIsControll/apiControll";
import { ModalWrapper } from "../../exports";
import PackConfirmModal from "./PackConfirmModal";
import styles from "./PackProdAndSaleVoucherModal.module.css";

const IMG_BASE =
  process.env.REACT_APP_S3URL || process.env.REACT_APP_S3URLA || "";

let boxCounter = 0;
const newBox = (file = null) => ({
  id: ++boxCounter,
  file,
  preview: file ? URL.createObjectURL(file) : null,
});

const DropIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <rect
      x="12"
      y="14"
      width="24"
      height="18"
      rx="4"
      stroke="#C0393B"
      strokeWidth="2"
    />
    <rect
      x="4"
      y="6"
      width="24"
      height="18"
      rx="4"
      stroke="#6B7499"
      strokeWidth="2"
      fill="#1B1D21"
    />
  </svg>
);

const PackProdAndSaleVoucherModal = ({
  mode,
  closeModal,
  managerId,
  orderId, // voucherId
  getData, // getData(true) must return the latest packingImgs array
  packingImgs = [],
}) => {
  const { show } = useToast();

  const [uploadedImgs, setUploadedImgs] = useState(packingImgs || []);
  const [boxes, setBoxes] = useState(() => [newBox()]);
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dragId, setDragId] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const inputRefs = useRef({});
  const boxesRef = useRef(boxes);
  boxesRef.current = boxes;

  const packCount = uploadedImgs.length;
  const selectedBoxes = boxes.filter((b) => b.file);

  useEffect(
    () => () => {
      boxesRef.current.forEach(
        (b) => b.preview && URL.revokeObjectURL(b.preview),
      );
    },
    [],
  );

  const addBox = () => setBoxes((prev) => [newBox(), ...prev]);

  const removeBox = (id) => {
    const target = boxesRef.current.find((b) => b.id === id);
    if (target?.preview) URL.revokeObjectURL(target.preview);
    setBoxes((prev) => {
      const next = prev.filter((b) => b.id !== id);
      return next.length ? next : [newBox()];
    });
  };

  // Click-select and drag-drop both use this.
  // First image fills this box, extra images get their own new boxes.
  const pickFiles = (id, fileList) => {
    const files = Array.from(fileList || []).filter((f) =>
      f.type.startsWith("image/"),
    );
    if (files.length === 0) {
      show("Please select an image file.", "warning");
      return;
    }

    const [first, ...rest] = files;
    const firstPreview = URL.createObjectURL(first);
    const extras = rest.map((f) => newBox(f));

    const old = boxesRef.current.find((b) => b.id === id);
    if (old?.preview) URL.revokeObjectURL(old.preview);

    setBoxes((prev) => [
      ...extras,
      ...prev.map((b) =>
        b.id === id ? { ...b, file: first, preview: firstPreview } : b,
      ),
    ]);
  };

  const openPicker = (id) => {
    if (uploading) return;
    inputRefs.current[id]?.click();
  };

  const handleDrop = (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    setDragId(null);
    if (uploading) return;
    pickFiles(id, e.dataTransfer.files);
  };

  // ONE button -> uploads all selected images in a single request
  const handleUploadAll = async () => {
    if (selectedBoxes.length === 0) {
      show("Please select at least one image.", "warning");
      return;
    }

    const formData = new FormData();
    formData.append("managerId", managerId);
    formData.append("voucherId", orderId);
    selectedBoxes.forEach((b) => formData.append("images", b.file));

    try {
      setUploading(true);
      const res = await handleFileData(
        "packing/uploadMultiPackedImg",
        formData,
      );

      if (res.status === "success") {
        show(res.msg || "Images uploaded", "success");
        const latest = await getData(true);
        if (Array.isArray(latest)) setUploadedImgs(latest);

        selectedBoxes.forEach(
          (b) => b.preview && URL.revokeObjectURL(b.preview),
        );
        setBoxes((prev) => {
          const next = prev.filter((b) => !b.file);
          return next.length ? next : [newBox()];
        });
      } else {
        show(res.msg || "Image upload failed", "error");
      }
    } catch (error) {
      console.error(error);
      show("Image upload failed", "error");
    } finally {
      setUploading(false);
    }
  };

  // Step 1: Pack button -> validate, then open the confirm modal
  const handlePackClick = () => {
    if (selectedBoxes.length > 0) {
      show("Please upload the selected images first.", "warning");
      return;
    }
    if (packCount === 0) {
      show("Please upload at least one image.", "warning");
      return;
    }
    setConfirmOpen(true);
  };

  // Step 2: "Yes" in confirm modal -> hit the pack API
  const confirmPackOrder = async () => {
    try {
      setLoading(true);
      const res = await fetchData("packing/prodAndSaleVoucherPacked", {
        managerId,
        voucherId: orderId,
        packingQty: packCount,
      });
      if (res.status === "success") {
        show(res.msg || "Voucher packed", "success");
        setConfirmOpen(false);
        getData();
        closeModal();
      } else {
        show(res.msg || "Unable to pack voucher", "error");
        setConfirmOpen(false);
      }
    } catch (error) {
      console.error(error);
      show("Unable to pack voucher", "error");
      setConfirmOpen(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`${styles.modal} ${mode ? styles.dark : ""}`}>
      {/* ---------- Confirm modal (same pattern as AcceptOrderModal) ---------- */}
      <ModalWrapper
        isOpen={confirmOpen}
        onClose={() => !loading && setConfirmOpen(false)}
        noBtn
      >
        <PackConfirmModal
          mode={mode}
          heading={"Pack Voucher"}
          centerHeading={"Are you sure you want to pack this voucher?"}
          packCount={packCount}
          loading={loading}
          handleSubmit={confirmPackOrder}
          handleCloseModal={() => setConfirmOpen(false)}
        />
      </ModalWrapper>

      {/* ---------- Header ---------- */}
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <p className={styles.title}>Pack Voucher</p>
          <span className={styles.countBadge}>
            {packCount} pack{packCount === 1 ? "" : "s"} uploaded
          </span>
        </div>
        <div className={styles.closeBtn} onClick={closeModal}>
          <CloseIcon mode={mode} />
        </div>
      </div>

      <div className={styles.list}>
        {/* ---------- To upload (top) ---------- */}
        <div className={styles.section}>
          <div className={styles.sectionHead}>
            <p className={styles.sectionTitle}>To upload</p>
            <span className={styles.sectionCount}>{boxes.length}</span>
          </div>

          <div className={styles.grid}>
            {boxes.map((box, i) => (
              <div className={styles.tile} key={box.id}>
                <p className={styles.tileLabel}>
                  Pack {packCount + boxes.length - i}
                </p>

                {box.preview ? (
                  <div
                    className={`${styles.frame} ${
                      uploading ? styles.dropBusy : ""
                    }`}
                  >
                    <img
                      className={styles.img}
                      src={box.preview}
                      alt="Selected"
                      draggable={false}
                    />
                    <span className={`${styles.badge} ${styles.badgeNew}`}>
                      Ready
                    </span>
                    {!uploading && (
                      <button
                        type="button"
                        className={styles.removeBtn}
                        onClick={() => removeBox(box.id)}
                        aria-label="Remove image"
                      >
                        ×
                      </button>
                    )}
                  </div>
                ) : (
                  <div
                    role="button"
                    tabIndex={0}
                    className={`${styles.frame} ${styles.drop} ${
                      dragId === box.id ? styles.dropActive : ""
                    } ${uploading ? styles.dropBusy : ""}`}
                    onClick={() => openPicker(box.id)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        openPicker(box.id);
                      }
                    }}
                    onDragEnter={(e) => {
                      e.preventDefault();
                      setDragId(box.id);
                    }}
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.dataTransfer.dropEffect = "copy";
                      if (dragId !== box.id) setDragId(box.id);
                    }}
                    onDragLeave={(e) => {
                      if (!e.currentTarget.contains(e.relatedTarget))
                        setDragId(null);
                    }}
                    onDrop={(e) => handleDrop(e, box.id)}
                  >
                    <div className={styles.dropContent}>
                      <DropIcon />
                      <p className={styles.dropTitle}>
                        Drag &amp; Drop any file
                      </p>
                      <p className={styles.dropOr}>
                        or <span className={styles.browse}>browse files</span>{" "}
                        on your computer
                      </p>
                    </div>

                    {!uploading && boxes.length > 1 && (
                      <button
                        type="button"
                        className={styles.removeBtn}
                        onClick={(e) => {
                          e.stopPropagation();
                          removeBox(box.id);
                        }}
                        aria-label="Remove box"
                      >
                        ×
                      </button>
                    )}

                    <input
                      ref={(el) => (inputRefs.current[box.id] = el)}
                      className={styles.hiddenInput}
                      type="file"
                      accept="image/*"
                      multiple
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => {
                        pickFiles(box.id, e.target.files);
                        e.target.value = "";
                      }}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* ---------- Uploaded (below) ---------- */}
        <div className={styles.section}>
          <div className={styles.sectionHead}>
            <p className={styles.sectionTitle}>Uploaded</p>
            <span className={styles.sectionCount}>{uploadedImgs.length}</span>
          </div>

          {uploadedImgs.length === 0 ? (
            <p className={styles.emptyNote}>No packs uploaded yet.</p>
          ) : (
            <div className={styles.grid}>
              {uploadedImgs.map((path, i) => (
                <div className={styles.tile} key={path + i}>
                  <p className={styles.tileLabel}>Pack {i + 1}</p>
                  <div className={styles.frame}>
                    <a
                      className={styles.imgLink}
                      href={`${IMG_BASE}${path}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className={styles.img}
                        src={`${IMG_BASE}${path}`}
                        alt={`Pack ${i + 1}`}
                      />
                    </a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* ---------- Footer ---------- */}
      <div className={styles.footer}>
        <div className={styles.footerLeft}>
          <Button
            buttonBgColor={"#000000"}
            buttonTextColor={"#FFFFFF"}
            buttonText={"+ Add Pack"}
            buttonClick={addBox}
            disabled={uploading}
          />
          <Button
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#FFFFFF"}
            buttonText={`Upload Pack${selectedBoxes.length ? ` (${selectedBoxes.length})` : ""}`}
            buttonClick={handleUploadAll}
            loading={uploading}
            disabled={uploading || selectedBoxes.length === 0}
            
          />
        </div>
        <div className={styles.footerRight}>
          <Button
            buttonBgColor={"#000000"}
            buttonTextColor={"#FFFFFF"}
            buttonText={"Close"}
            buttonIcon={<Close />}
            buttonClick={closeModal}
          />
          <Button
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#FFFFFF"}
            buttonText={"Pack"}
            buttonIcon={<Pack />}
            buttonClick={handlePackClick}
            disabled={loading || uploading || packCount === 0}
          />
        </div>
      </div>
    </div>
  );
};

export default PackProdAndSaleVoucherModal;